module.exports = __webpack_public_path__ + "img/traveler-background-aviation.c6674fd6.svg";